module.exports = __webpack_public_path__ + "static/media/img_package-all.679f1b13.png";